import React, { useState, useEffect } from "react";
import Header from "components/Headers/Header";
import { Button, Card, CardBody, Col, Container, Modal, ModalBody, Row } from "reactstrap";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import previewBadge from "../../assets/img/custom/sport_badges_preview.png";
import sportBadgeImage from "../../assets/img/custom/sportBadge.png";
import oldSportBadgeImage from "../../assets/img/custom/sport_badges_background.png";

const SportBadges = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />
      <Container fluid className="mt--4">
        <Card className="shadow border-0 rounded-4 overflow-hidden mb-4">
          <div className="bg-gradient-primary p-4 text-white">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <span className="text-uppercase tracking-wider font-weight-600 text-white-50" style={{ fontSize: "10px", letterSpacing: "1.5px" }}>
                  VIDEO GUIDE
                </span>
                <h2 className="text-white mb-0 mt-1 font-weight-700">
                  Sport Badges
                </h2>
                <p className="text-white-50 mb-0 mt-2 font-weight-500" style={{ fontSize: "0.95rem" }}>
                  Learn how to navigate and manage your sport badges.
                </p>
              </div>
              <Button color="secondary" className="font-weight-bold shadow-sm mt-3 mt-md-0" onClick={toggle}>
                Go to Site
              </Button>
            </div>
          </div>

          <CardBody className="p-4" style={{ backgroundColor: "#f8fafc" }}>
            <div 
              className="embed-responsive embed-responsive-16by9 rounded-4 overflow-hidden shadow-sm bg-black mb-4"
              style={{ borderRadius: "12px", border: "1px solid #e2e8f0" }}
            >
              <iframe
                className="embed-responsive-item w-100"
                style={{ minHeight: isSmallScreen ? "250px" : "480px", border: "none" }}
                src="https://www.youtube.com/embed/o05siwhwBWI"
                title="Sport Badges Guide"
                allowFullScreen
              ></iframe>
            </div>

            <Row className="mt-5 align-items-stretch">
              <Col md="6" className="mb-4">
                <img src={sportBadgeImage} alt="Sport Badges New" className="w-100 rounded shadow-sm" style={{ height: "100%" }} />
              </Col>
              <Col md="6" className="mb-4">
                <img src={oldSportBadgeImage} alt="Sport Badges Original" className="w-100 rounded shadow-sm" style={{ height: "100%" }} />
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
      
      <Modal
        isOpen={modal}
        toggle={toggle}
        size="lg"
        className="modal-dialog modal-dialog-centered"
      >
        <div className="modal-content border-0 rounded-4 overflow-hidden shadow-lg">
          <div className="bg-gradient-primary p-4 text-white text-center">
            <h2 className="text-white mb-0 font-weight-700">Seasonal Sport Badges</h2>
            <p className="text-white-50 mb-0 mt-2 font-weight-500" style={{ fontSize: "0.95rem" }}>
              Configure your sport badges and showcase your achievements
            </p>
          </div>
          <ModalBody className="p-4" style={{ backgroundColor: "#f8fafc" }}>
            <Row className="align-items-center">
              <Col md="7">
                <div className="bg-white p-4 rounded-4 shadow-sm mb-3">
                  <p className="font-weight-600 text-dark mb-3" style={{ fontSize: "1.05rem", lineHeight: "1.6" }}>
                    Display badges based on your performance in different sports seasons.
                  </p>
                  <p className="text-muted" style={{ fontSize: "0.95rem", lineHeight: "1.6" }}>
                    Badges let your fans and sponsors know your current status and what sport you're focusing on right now.
                  </p>
                </div>
                
                <div className="bg-gradient-warning text-white p-3 rounded-4 shadow-sm mb-3 d-flex align-items-start" style={{ borderLeft: "4px solid #fb6340" }}>
                  <i className="fas fa-exclamation-triangle mt-1 mr-3 text-white" style={{ fontSize: "20px" }}></i>
                  <div>
                    <strong className="text-white" style={{ fontSize: "0.95rem" }}>Important Note:</strong>
                    <p className="mb-0 text-white mt-1" style={{ fontSize: "0.85rem", lineHeight: "1.4", opacity: 0.9 }}>
                      Sport badges highlight your seasonal activities. Update them regularly to keep your fans engaged!
                    </p>
                  </div>
                </div>
              </Col>
              
              <Col md="5" className="text-center">
                <div className="p-3 bg-white rounded-4 shadow-sm mb-4">
                  <img src={previewBadge} className="img-fluid rounded-3" style={{ maxHeight: "180px", objectFit: "contain" }} alt="sport badge preview" />
                </div>
                
                <div className="d-flex flex-column gap-3 justify-content-center">
                  <a
                    href="https://youtu.be/VPOnEKsHG0Q"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-100 mb-2 d-block"
                  >
                    <Button color="outline-danger" className="w-100 rounded-pill font-weight-bold">
                      <i className="fas fa-play mr-2"></i> Play Intro Video
                    </Button>
                  </a>
                  <Link
                    to="/admin/seasonal-badges"
                    className="w-100 d-block"
                    onClick={toggle}
                  >
                    <Button color="primary" className="w-100 rounded-pill font-weight-bold shadow">
                      Continue to Badges
                    </Button>
                  </Link>
                </div>
              </Col>
            </Row>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default SportBadges;
